import { Card, Container, Paper, Typography } from '@mui/material'
import React from 'react'

const SplitDescription = ({ heading1, heading2, content1, content2, img1, img2 }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        height: "auto",
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      {/* First Section */}
      {(heading1 || content1 || img1) && (
        <Container
          disableGutters
          sx={{
            display: "flex",
            margin: { xs: "10% auto", md: "8% 3% 0 10%" },
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            paddingX: 0,
            overflowX: "hidden",
            gap: { xs: "20px", md: "60px" }, // Increased gap on large screens
          }}
        >
          {/* Left-aligned on larger screens */}
          {(heading1 || content1) && (
            <Card
              sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: { xs: "100%", md: "50%" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              {heading1 && (
                <Typography
                  sx={{
                    fontFamily: "Orbitron",
                    fontWeight: "800",
                    fontSize: { xs: "22px", md: "40px" },
                    color: "#000000",
                    lineHeight: "120%",
                    letterSpacing: "2%",
                    justifyContent: { xs: "center", md: "flex-start" },
                    display: "flex",
                    paddingBottom: "8%",
                  }}
                >
                  {heading1}
                </Typography>
              )}
              {content1 && (
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: "normal",
                    color: "#000000",
                    fontSize: { xs: "14px", md: "25px" },
                    paddingX: { xs: "2%", md: "0" },
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  {content1}
                </Typography>
              )}
            </Card>
          )}

          {/* Image */}
          {img1 && (
            <Card
              sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: { xs: "100%", md: "50%" },
                marginTop: { xs: "5%", md: "0" },
              }}
            >
              <img
                src={img1}
                alt="ourgoal"
                style={{
                  height: "auto",
                  width: "100%",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </Card>
          )}
        </Container>
      )}

      {/* Second Section */}
      {(heading2 || content2 || img2) && (
        <Container
          disableGutters
          sx={{
            display: "flex",
            margin: { xs: "10% auto", md: "8% 3% 0 10%" },
            flexDirection: { xs: "column-reverse", md: "row" },
            alignItems: "center",
            paddingX: 0,
            overflowX: "hidden",
            gap: { xs: "20px", md: "60px" }, // Increased gap on large screens
          }}
        >
          {/* Image */}
          {img2 && (
            <Card
              sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: { xs: "100%", md: "50%" },
                marginTop: { xs: "5%", md: "0" },
              }}
            >
              <img
                src={img2}
                alt="insights"
                style={{
                  height: "auto",
                  width: "100%",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </Card>
          )}

          {/* Right-aligned on larger screens */}
          {(heading2 || content2) && (
            <Card
              sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                width: { xs: "100%", md: "50%" },
                textAlign: { xs: "center", md: "right" },
              }}
            >
              {heading2 && (
                <Typography
                  sx={{
                    fontFamily: "Orbitron",
                    fontWeight: "800",
                    fontSize: { xs: "22px", md: "40px" },
                    color: "#000000",
                    lineHeight: "120%",
                    letterSpacing: "2%",
                    display: "flex",
                    justifyContent: { xs: "center", md: "flex-end" },
                    paddingBottom: "8%",
                  }}
                >
                  {heading2}
                </Typography>
              )}
              {content2 && (
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: "normal",
                    color: "#000000",
                    fontSize: { xs: "14px", md: "25px" },
                    paddingX: { xs: "2%", md: "0" },
                    textAlign: { xs: "center", md: "right" },
                  }}
                >
                  {content2}
                </Typography>
              )}
            </Card>
          )}
        </Container>
      )}
    </Paper>
  );
}

export default SplitDescription;
